import React from 'react';

import { ButtonOutline } from '@pinvest/sirius-button';
import { ArrowLeft20Icon } from '@pinvest/sirius-icons';
import TopNavigationInner from '@pinvest/sirius-top-navigation/dist/top-navigation-inner';
import clsx from 'clsx';

import styles from './styles.module.css';
import type { CenterContentTemplateProps } from './types';

const CenterContentTemplate: React.FC<CenterContentTemplateProps> = ({
  children,
  onBack,
  title,
  mobileHidden = false,
  showBackButton = true
}) => {
  return (
    <div>
      <div className={clsx(styles.navbar, mobileHidden && styles['navbar_mobile-hidden'])}>
        <TopNavigationInner
          title={title}
          onBack={onBack}
        />
      </div>
      <div className={styles.template}>
        <div className={styles.template__wrapper}>
          <div className={styles['template__back-button']}>
            {showBackButton &&
              <ButtonOutline testId='btn-back-template' icon={<ArrowLeft20Icon />} onClick={onBack}>
                Kembali
              </ButtonOutline>
            }
          </div>
          <div className={styles.template__content}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenterContentTemplate;
